import React, { useState } from "react";
import { Button, Input, List, Space, Tabs, Tag, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { MyWorks } from "./components/MyWorks";

export const WorksStep = ({
  disabled = false,
  groups = [],
  onChange = () => {},
  selectedWorks = [],
}) => {
  const { isLoading } = useSelector(selectProject);

  if (isLoading) {
    return <MyLoader centered={true} />;
  }

  // const items = [
  //   {
  //     label: `Роботи`,
  //     key: 1,
  //     children: (
  //       <MyWorks
  //         disabled={disabled}
  //         groups={groups}
  //         selectedWorks={selectedWorks}
  //         onChange={onChange}
  //       />
  //     ),
  //   },
  //   {
  //     label: `Матеріали`,
  //     key: 2,
  //     children: <Materials disabled={disabled} onChange={onChange} />,
  //   },
  // ];
  // return <Tabs defaultActiveKey="1" items={items} centered />;
  return (
    <MyWorks
      disabled={disabled}
      groups={groups}
      selectedWorks={selectedWorks}
      onChange={onChange}
    />
  );
};
